/**
 * Header Navigation - Vanilla JS
 * Handles mobile menu toggle and scroll management
 */

import {
  ready,
  $,
  $$,
  toggleClass,
  hasClass,
  slideUp,
  slideDown,
  attr,
} from "./utils.js";

ready(() => {
  let hamburgerOpen = false;
  let scrollTop = 0;
  let scrollLeft = 0;

  const hamburger = $(".hamburger");
  const mobileNav = $(".mobile-navigation");
  const backdrop = $(".mobile-navigation__backdrop");
  const body = document.body;

  // Hamburger menu toggle
  if (hamburger && mobileNav) {
    hamburger.addEventListener("click", (event) => {
      event.preventDefault();
      toggleClass(mobileNav, "is-open");
      toggleClass(body, "menu-open");

      // Update aria-expanded attribute
      const isOpen = hasClass(mobileNav, "is-open");
      attr(hamburger, "aria-expanded", isOpen);

      if (!hamburgerOpen) {
        hamburgerOpen = true;
        disableScroll();
      } else {
        hamburgerOpen = false;
        enableScroll();
      }
    });
  }

  // Close menu on backdrop click
  if (backdrop && mobileNav) {
    backdrop.addEventListener("click", () => {
      mobileNav.classList.remove("is-open");
      body.classList.remove("menu-open");
      if (hamburger) attr(hamburger, "aria-expanded", false);
      hamburgerOpen = false;
      enableScroll();
    });
  }

  // Mobile navigation submenu setup
  if (mobileNav) {
    const navState = $(".mobile-navigation__state");
    const clickable = navState ? attr(navState, "data-clickable") : "false";

    // Add 'has-sub' class to parent items
    $$(".mobile-navigation li").forEach((li) => {
      if (li.querySelector("ul")) {
        li.classList.add("has-sub");
      }
    });

    // Add caret icons
    $$(".mobile-navigation .has-sub > a").forEach((link) => {
      const caret = document.createElement("em");
      caret.className = "mobile-navigation__caret";
      link.after(caret);
    });

    // Make links clickable or carets only
    if (clickable === "true") {
      $$(".mobile-navigation .has-sub > .mobile-navigation__caret").forEach(
        (caret) => {
          caret.classList.add("trigger-caret");
        },
      );
    } else {
      $$(".mobile-navigation .has-sub > a").forEach((link) => {
        link.classList.add("trigger-caret");
        attr(link, "href", "javascript:;");
      });
    }

    // Menu open/close on click
    $$(".mobile-navigation .has-sub > .trigger-caret").forEach((trigger) => {
      trigger.addEventListener("click", function (e) {
        e.preventDefault();
        const parentLi = this.parentElement;
        const submenu = parentLi.querySelector("ul");

        if (hasClass(parentLi, "is-open")) {
          // Close this menu
          parentLi.classList.remove("is-open");
          parentLi
            .querySelectorAll("li")
            .forEach((li) => li.classList.remove("is-open"));
          parentLi.querySelectorAll("ul").forEach((ul) => slideUp(ul, 200));
        } else {
          // Open this menu
          parentLi.classList.add("is-open");
          if (submenu) slideDown(submenu, 200);

          // Close siblings
          const siblings = Array.from(parentLi.parentElement.children).filter(
            (child) => child !== parentLi,
          );
          siblings.forEach((sibling) => {
            sibling.querySelectorAll("ul").forEach((ul) => slideUp(ul, 200));
            sibling.classList.remove("is-open");
            sibling
              .querySelectorAll("li")
              .forEach((li) => li.classList.remove("is-open"));
          });
        }
      });
    });
  }

  /**
   * Disable scroll when menu is open
   */
  function disableScroll() {
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

    window.onscroll = function () {
      window.scrollTo(scrollLeft, scrollTop);
    };
  }

  /**
   * Enable scroll when menu is closed
   */
  function enableScroll() {
    window.onscroll = function () {};
  }

  /**
   * Add scrolled class to header when page is scrolled
   */
  const header = document.querySelector(".main-header");
  const video_banner = document.querySelector(".video-banner");
  let lastScrollTop = 0;

  if (header) {
    window.addEventListener("scroll", () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > 50) {
        header.classList.add("is-scrolled");
        video_banner?.classList.add("is-scrolled");
      } else {
        header.classList.remove("is-scrolled");
        video_banner?.classList.remove("is-scrolled");
      }

      lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    });
  }
});
